'use strict';

wbApp.directive('wbEmailTemplateCombo', ['$timeout', '$translate', 'emailTemplatesSvc', 'gridSortSvc', 'tenantInfo',
    function ($timeout, $translate, emailTemplatesSvc, gridSortSvc, tenantInfo) {
        function formatResult(model) {
            if (!model) {
                return "";
            }

            var attachmentsCnt = model.attachments.length || '';

            if (model.isOverridden)
            {
                if (model.isCompatibleOverride) {
                    return "<div class='row'>" +
                             "<div class='col-md-10 text-success'><b>" + model.emailTemplateName + "</b></div>" +
                             "<div class='col-md-2 text-success'><b>" + attachmentsCnt + "</b></div>" +
                           "</div>";

                } else {
                    return "<div class='row'>" +
                             "<div class='col-md-10 text-danger'><b>" + model.emailTemplateName + "</b></div>" +
                             "<div class='col-md-2 text-danger'><b>" + attachmentsCnt + "</b></div>" +
                           "</div>";
                }
            } else {
                return "<div class='row'>" +
                         "<div class='col-md-10'>" + model.emailTemplateName + "</div>" +
                         "<div class='col-md-2'>" + attachmentsCnt + "</div>" +
                       "</div>";
            }
        }

        function formatSelection(model) {
            if (!model) {
                return "";
            }

            var attachmentsCnt = !!model.attachments.length
                ? ' (' + model.attachments.length + ')'
                : '';

            if (model.isOverridden) {
                if (model.isCompatibleOverride) {
                    return "<span class='text-success'><b>" + model.emailTemplateName + attachmentsCnt + "</b></span>";
                } else {
                    return "<span class='text-danger'><b>" + model.emailTemplateName + attachmentsCnt + "</b></span>";
                }
            } else {
                return model.emailTemplateName + attachmentsCnt;
            }
        }

        return {
            restrict: 'A',
            require: '?ngModel',
            priority: 1,
            link: function (scope, elm, attrs, controller) {

                function init() {
                    models.$promise.then(function () {
                        $timeout(function () {

                            $(elm).select2({
                                placeholder: $translate.instant('TXT_SELECT_EMAIL_TEMPLATE'),
                                formatResult: formatResult,
                                formatSelection: formatSelection,
                                dropdownAutoWidth: true,
                                allowClear: false,
                                minimumResultsForSearch: 5,
                                id: function (model) { return model.documentTemplateType + '_' + model.emailCategory; },
                                data: _.sortBy(models, function (a) { return gridSortSvc.localeSort(a, 'emailTemplateName'); }),
                                matcher: function (term, text, data) {
                                    return data.emailTemplateName.toUpperCase().indexOf(term.toUpperCase()) >= 0;
                                }
                            });

                            controller.$render();
                        });

                        controller.$render = function () {
                            elm.select2('val', controller.$viewValue);
                        };

                        elm.on('change', function () {
                            scope.$apply(function () {
                                controller.$setViewValue(elm.select2('val'));
                            });
                        });

                        attrs.$observe('disabled', function (value) {
                            elm.select2('enable', !value);
                        });

                        attrs.$observe('readonly', function (value) {
                            elm.select2('readonly', !!value);
                        });

                        elm.bind("$destroy", function () {
                            elm.select2("destroy");
                        });

                        controller.$render();
                    }, 1);
                }

                var models = emailTemplatesSvc.getAllInfo(tenantInfo.languageAlias || 'cs', true);

                scope.$on('refreshEmailTemplateData', function (e, data) {
                    models = emailTemplatesSvc.getAllInfo(tenantInfo.languageAlias || 'cs', true);
                    models.$promise.then(function () {
                        $timeout(function () {
                            var selection = elm.select2('val');
                            elm.select2('destroy');
                            init();
                            controller.$setViewValue(selection);
                        });
                    });
                });

                init();
            }
        }
    }]);